import "../project.scss";
import "../projectResponse.scss";
import React, {useEffect, useState} from "react";

import {
    Helm,
} from "../../../components";
import {Route, useParams} from "react-router-dom";
import AllMatrix from "./AllMatrix";
import SingleMatrix from "./SingleMatrix";
import {request} from "../../../api/request";
import Auth from "./Popups/AuthPopup";

const Matrix = ({lang}) => {
    const [donors, setDonors] = useState({
        isFetched: false,
        data: {},
        error: null,
    });
    const [matrix, setMatrix] = useState({
        isFetched: false,
        data: {},
        error: null,
    });
    const fetchData = async () =>{
        request
            .get(`/donors/matrix/donors/?lang=${lang === null ? 'uz' : lang}`, {
                headers:{
                    "api-token":"p12378"
                }
            })
            .then((res) => {
                setDonors({
                    isFetched: true,
                    data: res.data,
                    error: false,
                });
            })
            .catch((err) => console.log(err));
        request
            .get(`/donors/matrix/matrix/?lang=${lang === null ? 'uz' : lang}`, {
                headers:{
                    "api-token":"p12378"
                }
            })
            .then((res) => {
                setMatrix({
                    isFetched: true,
                    data: res.data,
                    error: false,
                });
            })
            .catch((err) => console.log(err));
    }
    useEffect(()=>{
        fetchData()
    },[lang])

    return (
        <div className="matrix-module">
            <Helm id={"36"} />
            <div className="donr-cards" id="donr">
                <h5 className="section-holder ">
                    {lang === "uz"
                        ? "Project matrix"
                        : lang === "ru"
                            ? "Матрица проекта"
                            : lang === "en"
                                ? "Loyiha matritsasi"
                                : ""}
                </h5>

                <Route exact path="/project/matrix">
                    <AllMatrix lang={lang} donors = {donors}/>
                </Route>
                <Route exact path="/project/matrix/:id">
                    <SingleMatrix lang={lang} donors = {donors} matrix = {matrix} fetchMatrix={fetchData}/>
                </Route>
                <Route exact path="/project" >
                    <AllMatrix lang={lang} donors = {donors}/>
                </Route>
            </div>
        </div>
    );
};

export default Matrix;
